module.exports = __webpack_public_path__ + "static/media/h11_edu_bw.d3923506.webp";